import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Textarea } from '../../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Plus, Trash2 } from 'lucide-react';
import { COMPANY } from '../../../config/company';

/**
 * ClientNotesTab - Displays and manages client notes
 */
const ClientNotesTab = ({
  language,
  client,
  newNote,
  setNewNote,
  handleAddNote,
  handleDeleteNote,
  formatDate
}) => {
  return (
    <Card className="bg-white border-gray-200">
      <CardHeader>
        <CardTitle className="text-gray-900">
          {language === 'es' ? 'Notas' : 'Notes'}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {/* Add Note Form */}
        <div className="mb-6 p-4 rounded-lg bg-gray-100">
          <div className="flex gap-3 mb-3">
            <Select 
              value={newNote.note_type} 
              onValueChange={(v) => setNewNote({...newNote, note_type: v})}
            >
              <SelectTrigger className="bg-gray-100 border-gray-300 text-gray-900 w-32">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="general">
                  {language === 'es' ? 'General' : 'General'}
                </SelectItem>
                <SelectItem value="call">
                  {language === 'es' ? 'Llamada' : 'Call'}
                </SelectItem>
                <SelectItem value="email">Email</SelectItem>
                <SelectItem value="meeting">
                  {language === 'es' ? 'Reunión' : 'Meeting'}
                </SelectItem>
                <SelectItem value="follow_up">
                  {language === 'es' ? 'Seguimiento' : 'Follow-up'}
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Textarea
            value={newNote.content}
            onChange={(e) => setNewNote({...newNote, content: e.target.value})}
            placeholder={language === 'es' ? 'Agregar una nota...' : 'Add a note...'}
            className="bg-white border-gray-300 text-gray-900 placeholder:text-gray-400 mb-3"
            rows={3}
          />
          <Button 
            onClick={handleAddNote} 
            style={{ backgroundColor: COMPANY.primaryColor }} 
            className="text-gray-900"
          >
            <Plus className="mr-2 h-4 w-4" />
            {language === 'es' ? 'Agregar Nota' : 'Add Note'}
          </Button>
        </div>
        
        {/* Notes List */}
        <div className="space-y-3">
          {client.notes?.map(note => (
            <div 
              key={note.id} 
              className="p-4 rounded-lg bg-gray-100 border-l-4 border-amber-500"
            >
              <div className="flex justify-between items-start mb-2">
                <Badge variant="outline" className="text-gray-600 border-gray-300">
                  {note.note_type}
                </Badge>
                <div className="flex items-center space-x-2">
                  <span className="text-gray-500 text-xs">
                    {formatDate(note.created_at)}
                  </span>
                  <Button 
                    size="sm" 
                    variant="ghost" 
                    className="text-red-400 hover:text-red-300 h-6 w-6 p-0" 
                    onClick={() => handleDeleteNote(note.id)}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
              <p className="text-gray-800 whitespace-pre-wrap">{note.content}</p>
            </div>
          ))}
          {!client.notes?.length && (
            <p className="text-gray-500 text-center py-8">
              {language === 'es' ? 'Sin notas' : 'No notes yet'}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ClientNotesTab;
